export default {"src":"/_next/static/image/public/images/ic_reject_circle.44a923de145634ebc95fa87bdcdb7cbf.svg","height":22,"width":22};